/* =============================================
   WAVYY — theme.js
   ============================================= */

/* ---- SCROLL REVEAL ---- */
const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) entry.target.classList.add('visible');
  });
}, { threshold: 0.1 });

window.addEventListener('load', () => {
  document.querySelectorAll('.reveal').forEach(el => {
    if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('visible');
    revealObserver.observe(el);
  });
});

/* ---- PRODUCT QUANTITY SELECTOR ---- */
(function() {
  const qtyInput = document.getElementById('qty-input');
  if (!qtyInput) return;
  document.getElementById('qty-minus')?.addEventListener('click', () => {
    const v = parseInt(qtyInput.value) || 1;
    if (v > 1) qtyInput.value = v - 1;
  });
  document.getElementById('qty-plus')?.addEventListener('click', () => {
    qtyInput.value = (parseInt(qtyInput.value) || 1) + 1;
  });
})();

/* ---- PRODUCT FULL DETAILS SCROLL ---- */
(function() {
  const link = document.getElementById('full-details-link');
  const target = document.querySelector('.accordion-wrap');
  if (link && target) {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth' });
    });
  }
})();

/* ---- FAQ ACCORDION (homepage + why-wavyy) ---- */
document.querySelectorAll('.faq-question, .why-accordion-q, .accordion-q').forEach(btn => {
  btn.addEventListener('click', () => {
    btn.parentElement.classList.toggle('open');
  });
});

/* ---- CART DRAWER ---- */
(function() {
  const overlay = document.getElementById('cart-overlay');
  const drawer  = document.getElementById('cart-drawer');
  const itemsEl = document.getElementById('drawer-items');
  if (!overlay || !drawer) return;

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updateCartBadge(count) {
    const badge = document.getElementById('cart-badge');
    if (!badge) return;
    if (count > 0) {
      badge.textContent = count;
      badge.classList.add('visible');
    } else {
      badge.classList.remove('visible');
    }
  }

  function updateDrawerWithCart(cart) {
    const totalEl  = document.getElementById('drawer-subtotal');
    const footerEl = document.getElementById('drawer-footer');
    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<div class="drawer-empty"><p>nothing here yet.</p><p>go fix that.</p></div>';
      if (footerEl) footerEl.style.display = 'none';
      return;
    }

    if (footerEl) footerEl.style.display = '';
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    const shipNote = document.querySelector('.drawer-ship-note');
    if (shipNote) shipNote.style.display = cart.total_price >= 3500 ? 'none' : '';

    itemsEl.innerHTML = cart.items.map((item, idx) => {
      const lineNum     = idx + 1;
      const imgHtml     = item.image
        ? `<img src="${item.image}" alt="${item.product_title}">`
        : `<div class="drawer-item-img-placeholder"></div>`;
      const variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
        ? `<div class="drawer-item-variant">${item.variant_title}</div>` : '';

      return `
        <div class="drawer-item">
          <a href="${item.url}">${imgHtml}</a>
          <div class="drawer-item-info">
            <a href="${item.url}" class="drawer-item-name">${item.product_title}</a>
            ${variantHtml}
            <div class="drawer-item-price">${formatMoney(item.price)}</div>
          </div>
          <div class="drawer-item-right">
            <div class="drawer-line-total">${formatMoney(item.line_price)}</div>
            <div class="drawer-qty-wrap">
              <button class="drawer-qty-btn" data-line="${lineNum}" data-qty="${item.quantity - 1}" aria-label="Decrease quantity">−</button>
              <span class="drawer-qty-num">${item.quantity}</span>
              <button class="drawer-qty-btn" data-line="${lineNum}" data-qty="${item.quantity + 1}" aria-label="Increase quantity">+</button>
            </div>
          </div>
        </div>`;
    }).join('');
  }

  /* AJAX quantity update — delegated on itemsEl so it survives every innerHTML replacement.
     Uses /cart/change.js (JSON endpoint) — never causes a page redirect. */
  if (itemsEl) {
    itemsEl.addEventListener('click', function(e) {
      const btn = e.target.closest('.drawer-qty-btn');
      if (!btn) return;
      const line = parseInt(btn.dataset.line, 10);
      const qty  = parseInt(btn.dataset.qty, 10);
      if (isNaN(line) || isNaN(qty) || qty < 0) return;
      btn.disabled = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity: qty })
      })
        .then(r => r.json())
        .then(cart => {
          updateDrawerWithCart(cart);
          updateCartBadge(cart.item_count);
        })
        .catch(err => {
          console.error('Cart quantity update failed:', err);
          btn.disabled = false;
        });
    });
  }

  function openDrawer() {
    overlay.classList.add('open');
    drawer.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    overlay.classList.remove('open');
    drawer.classList.remove('open');
    document.body.style.overflow = '';
  }

  /* Exposed globally — fetches fresh cart state then opens */
  window.openCartDrawer = function() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        updateDrawerWithCart(cart);
        updateCartBadge(cart.item_count);
        openDrawer();
      })
      .catch(() => openDrawer());
  };

  overlay.addEventListener('click', closeCartDrawer);
  document.getElementById('drawer-close-btn')?.addEventListener('click', closeCartDrawer);
  document.getElementById('drawer-keep-shopping')?.addEventListener('click', closeCartDrawer);

  /* Initialise badge on page load */
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => updateCartBadge(cart.item_count))
    .catch(() => {});

  /* Intercept add-to-bag form */
  const addForm = document.getElementById('add-to-bag-form');
  if (addForm) {
    addForm.addEventListener('submit', function(e) {
      e.preventDefault();
      const formData = new FormData(this);
      const qty = parseInt(formData.get('quantity'), 10) || 1;
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(res => res.json())
        .then(item => {
          try {
            var anonKey = 'wavyy_anon_id';
            var anonId = localStorage.getItem(anonKey);
            if (!anonId) {
              anonId = 'anon-' + Math.random().toString(36).slice(2) + Date.now().toString(36);
              localStorage.setItem(anonKey, anonId);
            }
            fetch('https://a.klaviyo.com/client/events/?company_id=Ucwqda', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/vnd.api+json',
                'revision': '2026-07-15'
              },
              body: JSON.stringify({
                data: {
                  type: 'event',
                  attributes: {
                    metric: { data: { type: 'metric', attributes: { name: 'Added To Cart Custom' } } },
                    properties: {
                      'Product Title': item.product_title || item.title,
                      'Price': (item.price / 100).toFixed(2),
                      'Product URL': window.location.origin + item.url,
                      'Quantity': qty
                    },
                    profile: { data: { type: 'profile', attributes: { external_id: anonId } } }
                  }
                }
              })
            }).catch(function() {});
          } catch(e) {}
          return fetch('/cart.js');
        })
        .then(res => res.json())
        .then(cart => {
          updateDrawerWithCart(cart);
          updateCartBadge(cart.item_count);
          openDrawer();
        })
        .catch(err => console.error('Add to cart failed:', err));
    });
  }
})();

/* ---- REEL VIDEO SCROLL AUTOPLAY ---- */
(function() {
  var reelVideos = document.querySelectorAll('.reel-media-video');
  if (!reelVideos.length || !window.IntersectionObserver) return;
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.play().catch(function() {});
      } else {
        entry.target.pause();
      }
    });
  }, { threshold: 0.5 });
  reelVideos.forEach(function(v) { observer.observe(v); });
})();

(function() {
  var tiers = document.querySelectorAll('.bundle-tier');
  var variantInput = document.getElementById('bundle-variant-input');
  if (!tiers.length || !variantInput) return;
  tiers.forEach(function(tier) {
    tier.addEventListener('click', function() {
      tiers.forEach(function(t) { t.classList.remove('bundle-tier--active'); });
      tier.classList.add('bundle-tier--active');
      variantInput.value = tier.dataset.variantId;
    });
  });
})();
